import { Flex } from '@chakra-ui/react';
import { FC } from 'react';

import { useAvatarContext } from '../lib/context';
import { initials } from '../utils/name';

interface AvatarInitialsProps {
	name?: string;
}

const AvatarInitials: FC<AvatarInitialsProps> = ({ name }) => {
	const { textColor } = useAvatarContext();

	// TODO: Replace contents with custom text component after typography package is implemented
	return (
		<Flex
			alignItems="center"
			aria-label={name}
			color={textColor}
			fontFamily="ui"
			fontWeight="medium"
			h="full"
			justifyContent="center"
			letterSpacing="-0.013em"
			lineHeight="base"
			role="img"
			textTransform="uppercase"
		>
			{initials(name ?? '')}
		</Flex>
	);
};

AvatarInitials.displayName = 'AvatarInitials';

export { AvatarInitials };
